/**
 * Visible chat message for "Ask Koda" on an action item — action text + student only.
 *
 * Ask Koda only appears on items the counselor owns; student-owned items use Remind.
 * "Ana: send the worksheet" reads as work for Ana, so the ownership is stated instead,
 * otherwise Koda drafts a task assigning the counselor's own work to the student.
 */
export function buildKodaActionChatMessage(item, { studentName = '' } = {}) {
	const actionText = String(item?.text || '').trim() || '(no text provided)'
	const name = String(studentName || '').trim()
	const dueHint = String(item?.dueHint || '').trim()
	// The hint is the timing agreed in the session ("Friday"); without it Koda drafts
	// against its own default due date.
	const withDue = dueHint ? `${actionText} (due ${dueHint})` : actionText

	if (name) {
		return `My action item for ${name}: ${withDue}`
	}

	return `My action item: ${withDue}`
}
